module.exports = __webpack_public_path__ + "static/media/lock-fill-yellow.8352088d.svg";